import * as ng from 'angular';
import { UserService } from '../../../../../services/user.service';
import { CodiceDestinatarioService } from '../../../../../services/codice-destinatario.service';

class EnableFatturaPRModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        'store',
        'UserService',
        'CodiceDestinatarioService',
        '$q'
    ];

    private close: any;
    private dismiss: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService,
        private _userService: UserService,
        private _codiceDestinatarioService: CodiceDestinatarioService,
        private $q: any
    ) {
        $scope.updateInProgress = true;
        let updateCodiceDestinatario = () => {
            // const coddest = _codiceDestinatarioService.valoreCodiceDestinatario();
            const coddest = 'b2b';
            _userService.updateCodiceDestinatario(coddest)
                    .then((response) => {
                        store.set('user', response);
                        $scope.updateInProgress = false;
                    }, (error) => {
                        $rootScope.alert('error', error);
                    });
        };

        $scope.ok = () => {
            $state.go('home.fatturazione-pr');
            this.close();
        };
        $scope.cancel = () => {
            this.dismiss({ $value: 'cancel' });
        };
        updateCodiceDestinatario();
    }
}

export const EnableFatturaPRModalComponent: ng.IComponentOptions = {
    template: require('./enable-fattura-pr-modal.html'),
    controller: EnableFatturaPRModalController,
    bindings: {
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/enable-fattura-pr-modal/enable-fattura-pr-modal.ts